"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const chooseLocationContext_1 = require("../chooseLocationContext");
const CountryButton_1 = require("./CountryButton");
const context_1 = require("../../../context");
const CountryMenu = ({ focusedElementIndex, setFocusedElementIndex, searchInputRef, }) => {
    const { state } = (0, chooseLocationContext_1.useChooseLocationContext)();
    const { firstLineData: { currentCountry }, } = React.useContext(context_1.HeaderContext);
    const { countries, isNotFound, isCountryMenuOpened, dictionary } = state;
    const countryRefs = React.useRef([]);
    React.useEffect(() => {
        const focusElement = countryRefs.current[focusedElementIndex];
        if (!focusElement) {
            return;
        }
        focusElement.focus();
    }, [countries.length, focusedElementIndex]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "mt-md md:mt-2xs mb-3xl max-h-[calc(100dvh-280px)] overflow-y-auto md:mb-0 md:max-h-[280px]", children: !isNotFound && ((0, jsx_runtime_1.jsx)("ul", { className: "m-0 list-none p-0", id: "language-results", "aria-atomic": "true", "aria-live": "polite", "aria-hidden": !isCountryMenuOpened, "aria-label": dictionary.locationTitle, children: countries.map((country, index) => {
                const isSelected = country.countryName === (currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.countryName);
                return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)(CountryButton_1.default, { country: country, isSelected: isSelected, countryIndex: index, searchInputRef: searchInputRef, setFocusedElementIndex: setFocusedElementIndex, ref: buttonRef => (countryRefs.current[index] = buttonRef) }) }, country.url));
            }) })) }));
};
exports.default = CountryMenu;
